function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.343 2H6v11h20V8.234a.3.3 0 0 0-.227-.29L22 7l-2.388-4.833A.3.3 0 0 0 19.343 2z",
  stroke: "#fff",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10.5,
  cy: 13.5,
  r: 2.5,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 21.5,
  cy: 13.5,
  r: 2.5,
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M7 4H0M7 8H2"
});

const SvgTransfer = props => React.createElement("svg", _extends({
  width: 27,
  height: 16,
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4);

export default SvgTransfer;